import { NumberSettingData } from "./interfaces";

export const divideNumber = (number: number, operand: string, fraction: number) => {
  let result = [];

  // Divide by 100
  let hundreds = Math.floor(number / 100);
  for (let i = 0; i < hundreds; i++) {
    if (operand === "plus") {
      result.push(100);
    } else {
      result.push(-100);
    }
  }

  // Divide by 10
  let tens = Math.floor((number % 100) / 10);
  for (let i = 0; i < tens; i++) {
    if (operand === "plus") {
      result.push(10);
    } else {
      result.push(-10);
    }
  }

  // Divide by 1
  let ones = Math.trunc(number) % 10;
  for (let i = 0; i < ones; i++) {
    if (operand === "plus") {
      result.push(1);
    } else {
      result.push(-1);
    }
  }

  let numberFractions = Math.round((+number % 1) / fraction);
  for (let i = 0; i < numberFractions; i++) {
    if (operand === "plus") {
      result.push(fraction);
    } else {
      result.push(-fraction);
    }
  }

  return result;
};
export const validationNumbersFunc = (limits: { [k: string]: any }, data: NumberSettingData) => {
  const startNumber = Number(data.startNumber);
  const operandNumber = Number(data.operandNumber);
  const endLimit = Number(limits.interval.endNumber);
  const startLimit = Number(limits.interval.startNumber);

  if (Number.isNaN(startNumber)) {
    return `Invalid start number.`;
  }

  if (Number.isNaN(operandNumber)) {
    return `Invalid operand number.`;
  }

  const endSpanNum =
    data.operand === "plus" ? startNumber + operandNumber : startNumber - operandNumber;

  if (startNumber > endLimit || startLimit > startNumber) {
    return `The starting number must be with an interval from ${startLimit} to ${endLimit}`;
  }

  if (endSpanNum > endLimit || endSpanNum < startLimit) {
    return `The result number must be with an interval from ${startLimit} to ${endLimit}`;
  }

  return "";
};

export const getAnimatedNumber = (num?: number) => {
  if (!num) {
    return ["", ""];
  }

  if (Math.sign(num) === 1) {
    return ["+", num];
  }

  return ["-", Math.abs(num)];
};
